export default {
  configure: () => {},
  localNotification: () => {},
}  